import { useEffect, useRef } from 'react'

// this version can make too many unnecessary requests if used for searching and such (reacting to inputs)
// export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
// 	useEffect(() => {
// 		const handler = setTimeout(() => effect(), delay)
//
// 		return () => clearTimeout(handler)
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	}, [...(deps || []), delay])
// }

export const useDebouncedEffect = (effect: () => void, deps: any[], delay: number) => {
	const handlerRef = useRef<NodeJS.Timeout | null>(null)

	useEffect(() => {
		// Clear the previous timer before setting a new one
		if (handlerRef.current) {
			clearTimeout(handlerRef.current)
		}

		handlerRef.current = setTimeout(() => {
			effect()
		}, delay)

		// Cleanup on component unmount or when deps change
		return () => {
			if (handlerRef.current) {
				clearTimeout(handlerRef.current)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [...deps, delay])
}
